var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225 112.5C225 148.149 208.419 179.925 182.546 200.536C163.329 215.851 138.982 225 112.5 225C86.0177 225 61.6709 215.851 42.4538 200.536C16.5813 179.925 0 148.149 0 112.5C0 50.3686 50.3686 0 112.5 0C174.631 0 225 50.3686 225 112.5Z",
    fill: "#CED5D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 134.652C138.617 134.652 159.79 113.479 159.79 87.3617C159.79 61.2443 138.617 40.0719 112.5 40.0719C86.3823 40.0719 65.21 61.2443 65.21 87.3617C65.21 113.479 86.3823 134.652 112.5 134.652Z",
    fill: "#A6AFB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.546 200.536C163.329 215.851 138.983 225 112.5 225C86.018 225 61.6712 215.851 42.4541 200.536C51.5512 170.475 79.4696 148.59 112.5 148.59C145.531 148.59 173.449 170.475 182.546 200.536Z",
    fill: "#A6AFB2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.14dba302e5b89a96645943b5c8c9d7d8.svg";
export { ForwardRef as ReactComponent };